export enum ApiType {
    DEFAULT = 'default',
    HISTORY = 'history',
    BULK_REVIEW = 'bulk_review',
    REVIEW = 'review',
    FILE = 'file',
}

export enum GranularityType {
    NONE = 'none',
    HR = 'hr',
    DAY = 'd',
    WEEK = 'wk',
    MONTH = 'mo',
    QTR = 'qtr',
    YR = 'yr',
    ALL = 'all',
}

export enum UpdateType {
    CREATE = '10',
    UPDATE = '20',
    UPDATE_PERM = '21',
    UPDATE_SORT = '22',
    DELETE = '30',
    UPLOAD = '50',
    UPLOAD_CREATE = '51',
    UPLOAD_UPDATE = '52',
    UPLOAD_DELETE = '53',
}

export enum UpdateStatus {
    INIT = '0',
    APPROVE = '1',
    DECLINE = '2',
    CANCEL = '3',
    RETRACT = '4',
}

export enum State {
    REQ_INIT_VAL = 'INIT',
    REQ_INIT_VAL_2 = 'IN',
    REQ_INIT_VAL_1 = 'I',
    OPT_DEF_VAL = 'TBU',
    OPT_DEF_VAL_2 = 'TB',
    OPT_DEF_VAL_1 = 'T',
    NO_USE_VAL = 'NONE',
    NO_USE_VAL_2 = 'NO',
    NO_USE_VAL_1 = 'N',
    IGNORED_VAL = '------',
    IGNORED_VAL_X_3 = 'xxx',
    IGNORED_VAL_X_4 = 'xxxx',
}

export enum FlagType {
    FALSE = '0',
    TRUE = '1',
}
